import { render, staticRenderFns } from "./VlExaminationDateFilter.vue?vue&type=template&id=b04cdd54&scoped=true&"
import script from "./VlExaminationDateFilter.vue?vue&type=script&lang=js&"
export * from "./VlExaminationDateFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b04cdd54",
  null
  
)

export default component.exports